import {
  AsyncGridColumns,
  ColumnAmount,
  ColumnDate,
  ColumnLink,
} from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.full name',
    field: 'fullName',
    minWidth: 360,
    renderCell: ({ row }) => (
      <ColumnLink to={`/drivers/${row.id}/details`}>{row.fullName}</ColumnLink>
    ),
  },
  {
    headerName: 'column.driving license number',
    field: 'drivingLicenseNumber',
    sortable: false,
    minWidth: 214,
  },
  {
    headerName: 'column.contact phone',
    field: 'phone',
    sortable: false,
    minWidth: 180,
  },
  {
    headerName: 'column.e-mail',
    field: 'email',
    sortable: false,
    minWidth: 214,
    flex: 1,
  },
  {
    headerName: 'column.status',
    field: 'status',
    sortable: false,
    minWidth: 280,
    renderCell: ({ value }) => (
      <ChipStatus labelI18n={value.label} variant={value.color} />
    ),
  },
  {
    headerName: 'column.date of birth',
    field: 'birthDate',
    sortable: false,
    minWidth: 214,
    renderCell: ({ value }) => <ColumnDate type='date' value={value} />,
  },
  {
    headerName: 'column.current balance',
    field: 'mainBalance',
    minWidth: 160,
    renderCell: ({ value }) => {
      if (!value) return null
      return (
        <ColumnAmount
          amount={value}
          moveFunds={value >= 0 ? 'COMING' : 'SPENDING'}
        />
      )
    },
  },
  {
    headerName: 'column.credit balance',
    field: 'debtBalance',
    minWidth: 160,
    renderCell: ({ value }) => {
      if (!value) return null
      return (
        <ColumnAmount
          amount={value}
          moveFunds={value >= 0 ? 'COMING' : 'SPENDING'}
        />
      )
    },
  },
  {
    headerName: 'column.snils',
    field: 'snils',
    sortable: false,
    minWidth: 140,
    flex: 1,
  },
  {
    headerName: 'column.work rule',
    field: 'workRule',
    sortable: false,
    minWidth: 214,
    flex: 1,
  },
  {
    headerName: 'column.car',
    field: 'car',
    sortable: false,
    minWidth: 214,
    flex: 1,
    renderCell: ({ row, value }) => (
      <ColumnLink to={`/cars/${row.carId}/details`}>{value}</ColumnLink>
    ),
  },
  {
    headerName: 'column.yandex work rule',
    field: 'yandexWorkRule',
    sortable: false,
    minWidth: 214,
    flex: 1,
  },
]
